jQuery(document).ready(function() {
    TRACKING.onReady();
});


var TRACKING = {
    settings: {
        'gaProperty'     : 'UA-56591928-5',
        'ga4Property'    : 'G-RN3V0G678P'
    },


    onReady: () => {
        TRACKING.optInInit();
    },


    optInInit: () => {
        var cookieStatus = TRACKING.checkOptinCookie();
        var mySettings  = '';

        // Check if Cookie is set
        if (cookieStatus == false) {
            var settings    = '';
            var options     = '';  

            TRACKING.showModal();
            
            mySettings  = TRACKING.evaluateSettings(options, settings, true);
        }


        jQuery(document).on('click', '.btn-optin', function(e) {
            e.preventDefault();
            TRACKING.deleteAllCookies();

            TRACKING.setCookie('cookie_settings', mySettings[1], 31536000000); // 1 year

            jQuery('.modal-cookies')
                .fadeOut( function(){
                    jQuery('.navbar  .navbar-burger').before(jQuery('.select-language'));
                    jQuery(this).remove();
                });
            TRACKING.activateTracking();
        });

        jQuery(document).on('change', '.switch input', function(e) {
            settings    = '';
            options     = '';        
            mySettings  = TRACKING.evaluateSettings(options, settings, true);   
        });


        jQuery(document).on('click', '.show_settings', function(e) {
            e.preventDefault();
            
            jQuery('.modal-cookies .settings input').prop( 'checked', false );
            jQuery('.modal-cookies .settings input[name="bing_maps"]')
            	.prop( 'checked', true )
            	.prop( 'disabled', true );

            jQuery('.modal-cookies .settings').slideDown();
            jQuery('.modal-cookies .modal-content').addClass('extended');
            jQuery(this).parent().remove();
            jQuery('.btn-optin').text( jQuery('.btn-optin').attr('data-settings-text') );
            
            mySettings  = TRACKING.evaluateSettings(options, settings, true);   
        });
    },
    

    checkOptinCookie: () => {
        var myCookie = TRACKING.getCookie('cookie_settings');
        var status = true;

        var settings = '';
        var options = '';  
        var mySettings = TRACKING.evaluateSettings(options, settings, false);

        if (myCookie != null) {
            var myCookieLength = myCookie.split(",");
            TRACKING.activateTracking(TRACKING.settings);
            
        } else {
            status = false;
        }

        return status;
    },


    showModal: () => {
        jQuery('.modal-cookies').addClass('is-active');
        jQuery('.modal-cookies .has-lang-switch').append(jQuery('.select-language'));
        jQuery('.modal-cookies .settings input').prop( 'checked', true );
    },
    


    /*
    /* @param string     length          Number of tracking methods stored in the cookie "cookie_settings"
    /* @param string     value:          Value of the cookie "cookie_settings" with settings for each tracking method, example: google_analytics=false,hotjar=false,facebook_pixel=false,linkedin_insight=false,google_optimize=false
    /* @param bool       settingsFromModal   Defines if modal settings should be retrieved or not.
     */
    evaluateSettings: (length, value, settingsFromModal) => {
    	var value = '';
        jQuery('.modal-cookies .cookie-settings').each(function(i,v) {
            var name = jQuery('input[type=checkbox]', v).attr('name');
            var val  = (jQuery('input[type=checkbox]', v).prop('checked') ) ? 'true' : 'false' ;  

            length = i;
            value += name+'='+val+',';
        });

        value = value.substring(0, value.length - 1); // remove last char 

        return [length, value]
    },
    

    deleteAllCookies: () => {
        var cookies = document.cookie.split("; ");
        for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            while (d.length > 0) {
                var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                var p = location.pathname.split('/');
                document.cookie = cookieBase + '/';
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/');
                    p.pop();
                };
                d.shift();
            }
        }
    },


    setCookie: (name, value, time) => {
        var expires = new Date();
        expires.setTime(expires.getTime() + time);
        document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    },


    getCookie: (name) => {
        var keyValue = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return keyValue ? keyValue[2] : null;
    },


    activateTracking: () => {
        var myCookie        = TRACKING.getCookie('cookie_settings');
        var cookieSettings  = myCookie.split(",");

        // console.log('Cookie: ' +myCookie);
        

        if ( jQuery.inArray( "google_analytics=true", cookieSettings ) >= 0) {
            // console.log( 'setting found: googleAnalytics' );
            TRACKING.googleAnalytics();
            TRACKING.googleAnalytics4();
        }
        if ( jQuery.inArray( "bing_maps=true", cookieSettings ) >= 0) {
        	if (jQuery('iframe.map').length >= 1)
        		jQuery('iframe.map').attr('src', jQuery('iframe.map').data('src'));
        } else {

        }

        if ( jQuery.inArray( "google_optimize=true", cookieSettings ) >= 0) {
            // console.log( 'setting found: google_optimize' );
            googleOptimize(TRACKING.settings);
        }
        if ( jQuery.inArray( "hotjar=true", cookieSettings ) >= 0) {
            // console.log( 'setting found: hotjar' );
            hotJar(TRACKING.settings);
        }
        if ( jQuery.inArray( "facebook_pixel=true", cookieSettings ) >= 0) {
            // console.log( 'setting found: facebook_pixel' );
            facebookPixel(TRACKING.settings);
        }    
        if ( jQuery.inArray( "linkedin_insight=true", cookieSettings ) >= 0) {
            // console.log( 'setting found: linkedin_insight' );
            linkedinInsight(TRACKING.settings);
        }
    },
    

    // Google Analytics
    googleAnalytics: () => {
        (function(i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;
            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m)
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

        ga('create', TRACKING.settings.gaProperty, 'auto');
        ga('set', 'anonymizeIp', true);
        ga('require', TRACKING.settings.gTmProperty);
        ga('send', 'pageview');  
    },



    // Google Analytics 4
    googleAnalytics4: () => {
        loadScript("https://www.googletagmanager.com/gtag/js?id=" + TRACKING.settings.ga4Property)
            .catch(
               // loadScript.bind(null, localSource) // Alterative Script URL
            )
            .then(
                  () => { // Success
                    window.dataLayer = window.dataLayer || [];
                    // function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', TRACKING.settings.ga4Property);

                  }, 
                  () => {} //Failure
            );
    },


    sendGA4event: (name, params) => {
        var myCookie        = TRACKING.getCookie('cookie_settings');
        var cookieSettings  = myCookie.split(",");

        if ( jQuery.inArray( "google_analytics=true", cookieSettings ) >= 0)
            gtag('event', name, params);
    }
}


function gtag(){dataLayer.push(arguments);}